<template>
  <div class="app-shell">
    <header class="topbar">
      <router-link class="brand" to="/map" aria-label="CrashlandsTools v6 首页">
        <span class="brand-mark">C6</span>
        <span>
          <strong>CrashlandsTools</strong>
          <small>Browser Edition</small>
        </span>
      </router-link>

      <nav class="main-nav" aria-label="主要导航">
        <router-link to="/map">地图</router-link>
        <router-link to="/quests">任务</router-link>
        <router-link to="/resources">资源规划</router-link>
      </nav>

      <span class="privacy-badge">纯本地处理</span>
    </header>

    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>
